/**
 * Shared configuration for creating the Payment Element Web Component.
 * This configuration defines the props interface between the web component
 * and the underlying React component.
 */
export const PAYMENT_ELEMENT_PROPS_CONFIG = {
  allowedPaymentMethods: 'string',
  amount: 'string',
  apiKey: 'string',
  capture: 'string',
  currency: 'string',
  env: 'string',
  guest: 'json',
  labels: 'string',
  lang: 'string',
  onRender: 'function',
  // Support hyphenated versions for HTML attributes
  'on-render': 'function',
  onLoadStart: 'function',
  'on-load-start': 'function',
  onLoadEnd: 'function',
  'on-load-end': 'function',
  onChange: 'function',
  'on-change': 'function',
  onError: 'function',
  'on-error': 'function',
  onSubmit: 'function',
  'on-submit': 'function',
  paymentMethodFilters: 'string',
  propertyId: 'string',
  // @TODO implement redirectAction type properly
  // redirectAction: 'json',
  scopedCss: 'boolean',
  theme: 'json',
} as const;
